<template>
  <div :class="['lr2-modal', {'hide': !show}]">
    <div class="lr-box">
      <div class="lr-alert-msg" v-html="message"></div>
      <div class="op-btn btn-md btn-block btn-danger login-btn" @click="show = false">Close</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'alert',
  computed: {
    alert () { return this.$store.state.global.alert },
    show: {
      get () { return this.alert.show },
      set (x) {
        if (this.alert.action === 'redirectToHome') {
          this.$router.push('search')
        }
        this.$store.commit('global/setAlertData', {
          show: x,
          message: '',
          action: ''
        })
      }
    },
    message () { return this.alert.message }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.lr-box {
  padding: 20px;
  min-width: 300px;
  max-width: 500px;
}


.lr-alert-msg{
  margin-bottom: 20px;
  color: #45505b;
}
</style>



// WEBPACK FOOTER //
// Alert.vue?b87baf4a